import React, { Component, PropTypes } from 'react';
import Icon from '../tc-ui/icon';

class AddItemCard extends Component {

  render() {
    return (
      <div
        onClick={this.props.onClick}
        className="add-item-card"
        id={this.props.id}
      >
        <Icon style={{
          verticalAlign: 'middle',
          textAlign: 'center',
          fontSize: '49px' }} className="tc-icon-add"
        />
          <span style={{ verticalAlign: 'middle', lineHeight: '24px', fontSize: '42px' }}>
            {this.props.text}
          </span>
      </div>
    );
  }
}

AddItemCard.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  id: PropTypes.string,
};

export default AddItemCard;



// WEBPACK FOOTER //
// ./src/app/components/profile/add-item-card.jsx